import { Alert } from "capitalrx-components-2.0/lib";
import { OverlayContainer, TooltipContainer } from "capitalrx-components-2.0/lib/general";
import { BasicRoutes } from "@/basic/routes";

import { ThemeSelector } from "@/basic/context";

export const BasicRoot = (): JSX.Element => {
  const { AlertProvider } = Alert;

  return (
    <OverlayContainer>
      <TooltipContainer>
        <ThemeSelector>
          <AlertProvider>
            <BasicRoutes />
          </AlertProvider>
        </ThemeSelector>
      </TooltipContainer>
    </OverlayContainer>
  );
};
